<template>
  <div class="software-container side-gap" :class='$layout.isMobile ? "mobile" : undefined'>
    <h1>Мы настроим</h1>
    <div class="software-list flex-row space-between">
      <template v-for="item in items">
        <SoftwareIcon :color="$layout.isMobile" :key="item.name" :name="item.name"/>
      </template>
    </div>
  </div>
</template>

<script>
import software from "@/cfg/software.js"
import SoftwareIcon from "@/components/SoftwareIcon";

export default {
  name: 'WelcomeSoftware',
  components: {
    SoftwareIcon,
  },
  data() {
    return {
      items: software,
    }
  },
}
</script>

<style lang="scss" scoped>

.software-container.mobile {
  .software-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px 10px;
  }
}

.software-container {
  padding-top: 100px;
  padding-bottom: 100px;
  color: $color-1-active;

  .software-list {
    margin-top: 50px;
    color: $color-1;
    gap: 10px;
  }
}
</style>
